import { Modal } from "antd";
import type React from "react";
import { DELETE_RESOURCE_DESC, DELETE_RESOURCE_TITLE } from "@/common/messages";

/** The plain "delete this resource" confirm shared by every resource table's delete action. */
export function confirmDeleteResource(onOk: () => void) {
	Modal.confirm({
		title: DELETE_RESOURCE_TITLE,
		content: DELETE_RESOURCE_DESC,
		onOk,
	});
}

/**
 * A destructive confirm with a caller-chosen title/content, e.g. "Remove member". `onOk`
 * does the mutation and its own success/error notifications — this only owns the dialog.
 */
export function confirmDestructive({
	title,
	content,
	okText = "Remove",
	danger = true,
	onOk,
}: {
	title: React.ReactNode;
	content?: React.ReactNode;
	okText?: string;
	danger?: boolean;
	onOk: () => void;
}) {
	Modal.confirm({
		title,
		content,
		okText,
		okButtonProps: { danger },
		onOk,
	});
}
